import React from 'react';

import Link from "./Link"

import CERT from './SolutionCertificate';
import FeaturedSolutionCard from './FeaturedSolutionCard';

export default class extends React.Component {
    getRepoHost() {
      return this.props.repohost || '';
    }

    render() {
        if (!this.props.config && !this.props.data) return null;

        const data = this.parseData();

        if (!data) return null;

        if (data.contentSubtype == 'story') {
            return (
                <FeaturedSolutionCard data={data} />
            );
        }

        return this.renderCard(data);
    }

    renderCard(data) {
        const platform = data.complexity;
        const technology = data["technologyAreas"] && data["technologyAreas"].length && data["technologyAreas"][0].toLowerCase();
        const orderIndex = this.getOrderIndex(platform, data);
        const cardDetail = this.renderCardDetail(platform, technology, data, orderIndex);

        let companyLogoURL = data.meta.CompanyLogoURL;
        let partnerProfileURL = null;
        let solutionDetailLink = null;
        let partnerProfileLink = null;

        if (platform === "meraki") {
            partnerProfileURL = `${this.getRepoHost()}/ecosystem/meraki/apps/${data.id}/`;
            solutionDetailLink = <Link to={partnerProfileURL} className="sic-detail">{cardDetail}</Link>;
            partnerProfileLink =
                <span className="sic-company-link">{data.meta.CompanyName || data.name}</span>;
        }

        if (platform === "webex") {
            partnerProfileURL = `${this.getRepoHost()}/ecosystem/webex/apps/${data.id}/`;
            solutionDetailLink = <Link to={partnerProfileURL} className="sic-detail">{cardDetail}</Link>;
            partnerProfileLink =
                <span className="sic-company-link">{data.meta.CompanyName}</span>;
        }

        if (platform === "kinetic") {
            partnerProfileURL = `${this.getRepoHost()}/ecosystem/iot/partners/${data.id}/`;
            solutionDetailLink = <Link to={partnerProfileURL} className="sic-detail">{cardDetail}</Link>;
        }

        if (platform === "dnac") {
            partnerProfileURL = `${this.getRepoHost()}/ecosystem/dnacenter/partners/${data.id}/`;
            solutionDetailLink = <Link to={partnerProfileURL} className="sic-detail">{cardDetail}</Link>;
        }

        if (platform === "datacenter") {
            partnerProfileURL = `${this.getRepoHost()}/ecosystem/datacenter/partners/${data.id}/`;
            solutionDetailLink = <Link to={partnerProfileURL} className="sic-detail">{cardDetail}</Link>;
            partnerProfileLink =
                <a className="sic-company-link">{data.meta.CompanyName}</a>;
        }

        if (platform === "dsi") {
            partnerProfileURL = `${this.getRepoHost()}/ecosystem/dsi/partners/${data.id}/`;
            solutionDetailLink = <Link to={partnerProfileURL} className="sic-detail">{cardDetail}</Link>;
        }

        if (platform === "marketplace") {
            solutionDetailLink = `${this.getRepoHost()}/ecosystem/spp/solutions/${data.id}/`;
            solutionDetailLink = <Link to={solutionDetailLink} className="sic-detail">{cardDetail}</Link>;

            partnerProfileURL = `${this.getRepoHost()}/ecosystem/spp/partners/${data.meta.CompanyProfileID}/`;
            partnerProfileLink =
                <Link to={partnerProfileURL} className="sic-company-link">{data.meta.CompanyName}</Link>;

            // logo
            companyLogoURL = data.meta.CompanyLogoURL
        }
        if (platform === "security") {
            partnerProfileURL = `${this.getRepoHost()}/ecosystem/security/partners/${data.id}/`;
            solutionDetailLink = <Link to={partnerProfileURL} className="sic-detail">{cardDetail}</Link>;
        }

        /* [start] data.contentSubtype == "smartsheet" -- broadsoft, sd-wan, cat9k */
        if (platform === "broadsoft") {
            partnerProfileURL = `${this.getRepoHost()}/ecosystem/broadsoft/partners/${data.id}/`;
            solutionDetailLink = <Link to={partnerProfileURL} className="sic-detail">{cardDetail}</Link>;
        }

        if (platform === "sd-wan") {
            partnerProfileURL = `${this.getRepoHost()}/ecosystem/sdwan/partners/${data.id}/`;
            solutionDetailLink = <Link to={partnerProfileURL} className="sic-detail">{cardDetail}</Link>;
        }

        if (platform === "cat9k") {
            partnerProfileURL = `${this.getRepoHost()}/ecosystem/wireless-iot/apps/${data.id}/`;
            solutionDetailLink = <Link to={partnerProfileURL} className="sic-detail">{cardDetail}</Link>;
            partnerProfileLink = <Link to={partnerProfileURL} className="sic-company-link">{data.meta.CompanyName}</Link>;
        }

        if (data.contentSubtype == "smartsheet") {
            if (data.url) {
                // remove domain from the url field
                // e.g. "https://testing-developer.cisco.com/ecosystem/abu/partners/EX0021/"
                partnerProfileURL = data.url.split("cisco.com").pop();
                solutionDetailLink = <Link to={partnerProfileURL} className="sic-detail">{cardDetail}</Link>;
            }
        }
        /* [end] data.contentSubtype == "smartsheet"  */

        // general listing
        if (!solutionDetailLink && !partnerProfileLink) {
            partnerProfileURL = `${this.getRepoHost()}/ecosystem/${data.contentSubtype}/partners/${data.id}/`;
            solutionDetailLink = <Link to={partnerProfileURL} className="sic-detail">{cardDetail}</Link>;
        }

        if (platform === "specialization") {
            const id = data.id.startsWith("P") ? data.id.slice(1) : data.id;
            partnerProfileURL = `${this.getRepoHost()}/ecosystem/partners/${id}/`
            solutionDetailLink = <Link to={partnerProfileURL} className="sic-detail">{cardDetail}</Link>;
        }

        if (platform === "fusion") {
            partnerProfileURL = `${this.getRepoHost()}/ecosystem/cpp/${data.contentSubtype}s/${data.id}/`;
            solutionDetailLink = <Link to={partnerProfileURL} className="sic-detail">{cardDetail}</Link>;
        }

        const logo = partnerProfileURL && partnerProfileURL.startsWith("http")
            ? <a href={partnerProfileURL} className="sic-logo" target="_blank" rel="noopener noreferrer"><img src={companyLogoURL}
                alt={data.meta.CompanyName} /></a>
            : <Link to={partnerProfileURL} className="sic-logo"><img src={companyLogoURL}
                alt={data.meta.CompanyName} /></Link>;

        const fusionClassName = this.buildFusionClassName(platform, data);

        return (
            <div className={("sic " + fusionClassName).trim()}
                data-platform={platform}
                data-order={orderIndex}
                data-technology={technology}>
                <div data-track-name="card:solution_detail" data-track-value={data.name}>
                    {solutionDetailLink}
                </div>
                <div data-track-name="card:solution_logo" data-track-value={data.meta.CompanyName}>
                    {logo}
                </div>

                <div data-track-name="card:solution_partner_name" data-track-value={data.meta.CompanyName}>
                    {partnerProfileLink}
                </div>
            </div>
        );
    }

    renderCardDetail(platform, technology, data, orderIndex) {
        let title = data.name;
        if (platform === "meraki") {
            title = data.meta.TagLine || title;
        }
        if (data.contentSubtype == "smartsheet") {
            title = title || data.meta.CompanyName
        }

        const description = data.description.trim();
        const tags = this.renderTags(platform, data);
        const platform_label = this.getPlatformLabel(platform, data);
        const certs = this.renderCerts(data);
        const fusionLog = this.renderFusionLogo(platform, data);

        return (<div>
            <div className="sic-detail-bg" data-platform={platform} data-order={orderIndex}
                data-technology={technology}></div>
            <div className="sic-detail-platform" data-platform={platform}>{platform_label}</div>
            <div className="sic-detail-title">{title}</div>
            <div className="sic-detail-description"
                title={description}>{description}</div>
            <div className="sic-detail-certs">
                {fusionLog} {certs} {tags}
            </div>
        </div>);
    }

    renderTags(platform, data) {
        let tags = null;
        if (platform === "webex") {
            if (data.meta.ApplicationType === 'bot') {
                tags = <div className="sic-detail-types">Bot</div>;
            } else if (data.meta.ApplicationType === 'integration') {
                tags = <div className="sic-detail-types">Integration</div>;
            }
        }

        return tags;
    }

    getPlatformLabel(platform, data) {
        if (this.isDNSP(data)) return "SolutionsPlus";
        if (platform == 'fusion') return "";

        const platform_label_mapping = {
            "dnac": "Cisco DNA Center",
            "datacenter": "Data Center",
            "marketplace": "SPP",
            "kinetic": "IoT",
            "meraki": "Meraki",
            "webex": "Webex",
            "security": "Security",
            "sd-wan": "SD-WAN",
            "broadsoft": "Broadsoft",
            "dsi": "DSI",
            "specialization": "DevNet Specialization",
            "cat9k": "Wireless IoT"
        };

        //platform_label
        return platform_label_mapping[platform] || platform;
    }

    renderCerts(data) {
        // certification
        const certs = [];
        if (data.meta.MembershipTypeID) {
            certs.push(<CERT index={(parseInt(data.meta.MembershipTypeID) - 1)} key={data.meta.MembershipTypeID} />);
        }

        // cisco compatibility
        if (data.meta.StatusID == "402") {
            certs.push(<CERT index="4" key="402" />);
        }

        return certs;
    }

    parseData() {
        let data = this.props.data;

        if (!data && this.props.config) {
            try {
                return JSON.parse(this.props.config.querySelector("data").textContent)
            } catch (e) {
                return null
            }
        }

        return data;
    }

    getOrderIndex(platform, data) {
        let index = 0;
        if (platform === "meraki") {
            index = data.id.charCodeAt(data.id.length - 1);
        } else if (this.props["order"]) {
            index = this.props["order"]
        } else if (this.props.config) {
            index = parseInt(this.props.config.getAttribute("order")) || parseInt(data.id.slice(-4)) || 0;
        } else {
            index = parseInt(data.id.slice(-4)) || 0;
        }

        return index % 6 + 1;
    }

    buildFusionClassName(platform, data) {
        if (platform != "fusion") return "";

        return "fusion fusion-" + data.contentSubtype;
    }

    isDNSP(data) {
        const DNSP_NUM = "765";
        return (data.categories || []).indexOf(DNSP_NUM) !== -1;
    }

    renderFusionLogo(platform, data) {
        if (platform != "fusion") return null;

        const PARTNER_TYPES = {
            "advisor-gold": "Gold Advisor",
            "advisor-premier": "Premier Advisor",
            "advisor-select": "Select Advisor",
            "dev-gold": "Gold Developer",
            "dev-premier": "Premier Developer",
            "dev-select": "Select Developer",
            "integrator-gold": "Gold Integrator",
            "integrator-premier": "Premier Integrator",
            "integrator-select": "Select Integrator",
            "provider-gold": "Gold Provider",
            "provider-premier": "Premier Provider",
            "provider-select": "Select Provider",
            //
            "advisorgold": "Gold Advisor",
            "advisorpremier": "Premier Advisor",
            "advisorselect": "Select Advisor",
            "devgold": "Gold Developer",
            "devpremier": "Premier Developer",
            "devselect": "Select Developer",
            "integratorgold": "Gold Integrator",
            "integratorpremier": "Premier Integrator",
            "integratorselect": "Select Integrator",
            "providergold": "Gold Provider",
            "providerpremier": "Premier Provider",
            "providerselect": "Select Provider",
        }

        const qualCodes = (data.meta.QualCodes || "").toLowerCase().split(",").filter(i => (i || "").trim());

        const categories = (data.categories || []).map(i => i.toLowerCase());

        const partnerType = qualCodes.find(i => PARTNER_TYPES[i]) || categories.find(i => PARTNER_TYPES[i]);

        if (!partnerType) return null;

        const tip = PARTNER_TYPES[partnerType];

        return (
            <div className={"fusion-partner-certificate " + partnerType} title={tip}></div>
        );
    }
}




